import { render, staticRenderFns } from "./vFormRADIOBUTTONS.vue?vue&type=template&id=15d4d0d6&scoped=true&"
import script from "./vFormRADIOBUTTONS.vue?vue&type=script&lang=js&"
export * from "./vFormRADIOBUTTONS.vue?vue&type=script&lang=js&"
import style0 from "./vFormRADIOBUTTONS.vue?vue&type=style&index=0&id=15d4d0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d4d0d6",
  null
  
)

export default component.exports